import "./styles.less";

import { Button, Grid } from "antd";
import { MouseEvent, useEffect, useRef, useState } from "react";
import { OwnerWspInterface, useWhatsppButton } from "./hook";

import { ModalWpp } from "../../../ModalWpp/web";
import { WhatsAppOutlined } from "@ant-design/icons";
import { useFacebookPixel } from "../../../../../GlobalHooks/web/FacebookPixel.hook";
// import { useGoogleAnalytics } from "../../../../../GlobalHooks/web/GoogleAnalytics.hook";
import { useRouter } from "next/router";
import { ModalState } from "../../TextForm/type";

const { useBreakpoint } = Grid;

export const WhatsappButton = ({ id, mode, disabled = false, queryRouter, onWpClick, forceState = ModalState.DEFAULT }: OwnerWspInterface) => {
	const router = useRouter();
	const FP = useFacebookPixel();
	const screen = useBreakpoint();
	// const GA = useGoogleAnalytics();
	const callWpp = useRef(null);
	const [modal, setModal] = useState(false);

	const {
		viewWpp,
		loading,
		linkWpp,
		wppPhone,
		operation_type_name,
		owner_name,
		hasWhatsapp,
	} = useWhatsppButton(id);

	// Simula el click de ver "Whatsapp"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "wpp") {
				if (callWpp.current) callWpp.current.click();
			}
		}, 3000);
	}, [queryRouter]);

	useEffect(() => {
		if (forceState == ModalState.CLOSE) {
			setModal(false);
		} else if (forceState == ModalState.OPEN) {
			setModal(true);
		}
	}, [forceState]);

	const sendEvent = () => {
		const categoryName: string = "Consultas Wpp";
		const action = operation_type_name ? operation_type_name : router.asPath;
		// GA.Event({
		// 	action: (screen.lg ? "Desktop" : "Mobile") + " " + action,
		// 	category: categoryName,
		// 	label: screen.lg ? "Consulta Wpp Desktop" : "Consulta Wpp Mobile",
		// });
		FP.StandardEvent(categoryName);
	};

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (hasWhatsapp) {
			viewWpp().then(data => {
				if (data) {
					sendEvent();
					setModal(true);
				}
			});
		} else {
			setModal(true);
			sendEvent();
		}
	};

	return (
		<>
			<Button
				ref={callWpp}
				className="wpp-button"
				loading={loading}
				disabled={disabled}
				onClick={handleClick}
				style={{ borderColor: "#00C841" }}
				icon={<WhatsAppOutlined style={{ color: "#00C841" }} />}
			/>
			<ModalWpp
				mode={mode}
				visible={modal}
				link={linkWpp}
				property_id={id}
				phone={wppPhone}
				loading={loading}
				onWpClick={onWpClick}
				owner_name={owner_name}
				onCancel={() => setModal(false)}
			/>
		</>
	);
};

